import { useState, useEffect } from "react";

const FileUpload = ({value, handleChange }) => {
  const [fileName, setFileName] = useState("");
  
  // Reset fileName when value is empty
  useEffect(() => {
    if (!value) {
      setFileName("");
    }
  }, [value]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      handleChange("postImage", file);
    }
  };

  return (
    <div className="relative w-full flex flex-col gap-1 group transition-all">
      <label
        className={`text-subtitle2 font-ptsans text-secondary/90 font-medium pl-2 block`}
      >
        Post Image
      </label>
        {/* Hidden File Input */}
        <input
          type="file"
          accept="image/*"
          key={value || "empty-input"} 
          onChange={handleFileChange}
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
        />

        {/* Custom File Input UI */}
        <div className="w-full h-12 flex items-center border-2 border-secondary/40 rounded-xl pl-3 pr-2 py-2 text-secondary/90 bg-background cursor-pointer group-hover:border-secondary/35">
          <span className="flex-1 truncate text-body1 font-ptsans text-secondary/90 group-hover:text-secondary/60">
            {fileName || "Choose a file..."}
          </span>
          <button
            type="button"
            className="ml-3 px-4 py-1.5 bg-secondary/90 text-background/90 rounded-lg text-sm font-medium hover:!bg-secondary/80 group-hover:bg-secondary/70 group-hover:text-background/75"
          >
            Browse
          </button>
        </div>
    </div>
  );
};

export default FileUpload;
